import Analytics from '@withlocals/withlocals-analytics';
import { Translator } from 'Translator';
import useFavoritesItem from 'hooks/useFavoriteItem';
import React, { useCallback } from 'react';

import { FavoritesButtonPresentational } from './FavoritesButton.presentational';

interface FavoritesButtonProps {
  experienceId: string;
  analyticsCategory: string;
  className?: string;
  variant?: 'default' | 'pink';
}

function FavoritesButton({
  experienceId,
  analyticsCategory,
  className,
  variant = 'default',
}: FavoritesButtonProps) {
  const { isFavorite, setAsFavorite, isLoading } =
    useFavoritesItem(experienceId);

  const toggleActive = useCallback(
    (event: React.MouseEvent) => {
      event.stopPropagation();
      Analytics.track(
        analyticsCategory,
        !isFavorite ? 'Add to Favorites' : 'Remove from Favorites',
        experienceId,
      );
      setAsFavorite(!isFavorite);
    },
    [analyticsCategory, experienceId, isFavorite, setAsFavorite],
  );

  const label = !isFavorite
    ? Translator.translate(
        'Common.Labels.favoritesAdd',
        {},
        true,
        'Add to favorites',
      )
    : Translator.translate(
        'Common.Labels.favoritesRemove',
        {},
        true,
        'Remove from favorites',
      );

  return (
    <FavoritesButtonPresentational
      isFavorite={isFavorite}
      variant={variant}
      disabled={isLoading}
      className={className}
      label={label}
      onClick={toggleActive}
    />
  );
}

export default FavoritesButton;
